import React from 'react';
import PropTypes from 'prop-types';

import styles from './split-background.scss';

const SplitBackground = ({ children, image }) => (
  <div className={styles.splitBackground}>
    <div className={styles.splitBackgroundInner}>
      <div className={styles.splitBackgroundContentWrap}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>

    <div className={styles.image} style={{ backgroundImage: `url('${image}')` }} />
  </div>
);

SplitBackground.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  image: PropTypes.string.isRequired,
};

export default SplitBackground;



// WEBPACK FOOTER //
// ./blocks/SplitBackground/index.js